<style scoped src="../../../css/selector-base.less" lang="less"></style>
<style lang="less" scoped>

</style>
<template>
  <VRemoteSelect
    v-bind="$attrs"
    item-value="id"
    :item-text="(c) => (`${c.uid}-${c.name}`)"
    :find_api="$util.api.find_expense_group"
    search_api="expense_group/select_return_search"
    :item-default="{id: 0, uid: '', name: ''}"
    v-on="$listeners"
  />
</template>
<script>
  import VRemoteSelect from '../../../vuetify_custom/v-remote-select';
  export default {
    components: { VRemoteSelect },
    inheritAttrs: false,
  }
</script>
